export default "__VITE_PUBLIC_ASSET__ec363d10__"